// This file is generated by pnpm icons:generate. Do not edit.

import {PageText_Stroke2_Corner0_Rounded as CanonicalPageText_Stroke2_Corner0_Rounded} from './Page'

/** @deprecated Import PageText_Stroke2_Corner0_Rounded from `#/components/icons/Page` instead. */
export const PageText_Stroke2_Corner0_Rounded =
  CanonicalPageText_Stroke2_Corner0_Rounded
